export const HUB_CONNECTION_CREATED = "HUB_CONNECTION_CREATED";
export const HUB_CONNECTION_CLOSED = "HUB_CONNECTION_CLOSED";

export const HUB_CONNECTION = {
  STATE: {
    CREATED: "HUB_CONNECTION_CREATED",
    CLOSED: "HUB_CONNECTION_CLOSED"
  },
  METHODS: {
    USER_LOGIN: "HUB_METHOD_USER_LOGIN",
    LEAVE_REQUEST: "HUB_METHOD_LEAVE_REQUEST",
    NOTIFICATION_UPDATE: "HUB_METHOD_NOTIFICATION_UPDATE",
  }
};
